import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import SwiperCore, { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { actionGetStoryPages } from '../../redux/education/actions/story.action';
import { Button, Modal } from 'react-bootstrap';
import { actionStoryReadingModalClose } from '../../redux/modal';
import { Keyboard, Navigation } from 'swiper/modules';
import { compareOrder } from '../../utils';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { exitIcon } from '../../_metronic/assets/icons';
import { storyInitialValues } from "../../constants";

const StoryReadingModal = () => {
    const [storyDetail, setStoryDetail] = useState(storyInitialValues)
    const handle = useFullScreenHandle();
    const dispatch = useDispatch();
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const [storyPageAllData, setStoryPageAllData] = useState({}); // Assume you have a state [storyPageAllData, setStoryPageAllData]
    const [storyPages, setStoryPages] = useState([]);
    const [storyPagesImageAllData, setStoryPagesImageAllData] = useState([]);
    const [totalPagesCount, setTotalPageCount] = useState(0);
    const [storyGroups, setStoryGroups] = useState([]);
    const [otherStoryPages, setOtherStoryPages] = useState([]); // Assume you have a state [otherStoryPages, setOtherStoryPages
    const [activePage, setActivePage] = useState(0);
    const [storyPagesAllData, setStoryPagesAllData] = useState([]);
    const swiper = useSwiper();
    const [sounds, setSounds] = useState([]);
    const audioRef = useRef(new Audio());
    const [soundStatus, setSoundStatus] = useState(true);
    const [audioPlaying, setAudioPlaying] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [isControlsVisible, setIsControlsVisible] = useState(false);

    const { storyReadingModalOpen, storyReadingModalField } = useSelector(
        (state) => state.modalReducer
    );

    useEffect(() => {
        const rootElement = document.getElementById('root');
        if (rootElement) {
            if (storyReadingModalOpen) {
                rootElement.classList.add('story-modal-open');
            } else {
                rootElement.classList.remove('story-modal-open');
            }
        }

        return () => {
            if (rootElement) {
                rootElement.classList.remove('story-modal-open');
            }
        };
    }, [storyReadingModalOpen]);

    useEffect(() => {
        const setVh = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        window.addEventListener('resize', setVh);
        setVh(); // Initial call

        return () => window.removeEventListener('resize', setVh);
    }, []);

    // Check if device is mobile or tablet
    useEffect(() => {
        const checkDevice = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 740);
            setIsTablet(width > 740 && width <= 1024);
        };

        const checkFullscreen = () => {
            console.log('Screen dimensions:', window.innerWidth, 'x', window.innerHeight);
            console.log('Width check:', window.innerWidth <= 768);
            console.log('Height check:', window.innerHeight <= 800);
            setIsFullscreen(window.innerWidth <= 768 || window.innerWidth <= 1200);
            console.log('isFullscreen result:', window.innerWidth <= 768 || window.innerHeight <= 800);
        };

        checkDevice();
        checkFullscreen();
        window.addEventListener('resize', checkDevice);
        window.addEventListener('resize', checkFullscreen);

        return () => {
            window.removeEventListener('resize', checkDevice);
            window.removeEventListener('resize', checkFullscreen);
        };
    }, []);

    // Fetches story pages data on modal open
    useEffect(() => {
        console.log('storyReadingModalField', storyReadingModalField);
        if (storyReadingModalField.StoryDetailId > 0 && storyReadingModalField.StoryId > 0) {
            getStoryPages(storyReadingModalField.StoryDetailId, storyReadingModalField.StoryId);
        }
    }, [storyReadingModalField]);


    // Plays the sound corresponding to the active image
    useEffect(() => {
        const playSound = (soundUrl) => {
            if (audioRef.current && soundStatus && audioPlaying) {
                audioRef.current.pause();
                audioRef.current = new Audio(soundUrl);
                audioRef.current.play().catch((error) => console.error('Error playing audio:', error));
            }
        };

        if (storyPages && sounds && activePage < storyPages.length) {
            const sound = sounds.find((s) => s.queueNo === storyPages[activePage].queueNo);
            if (sound) {
                const newAudioUrl = `${replaceObjectUrl(sound.fileContent)}`;
                playSound(newAudioUrl);
            }
        }
    }, [activePage, sounds]);

    // Retrieves story pages and sounds from the server
    //TODO
    const getStoryPages = (storyDetailId, storyId) => {
        audioRef.current = new Audio('');
        const width = window.innerWidth;
        let deviceTypeId;
        
        if (width >= 500 && width <= 840) {
            deviceTypeId = 2; // Mobile
        } else if (isMobile) {
            deviceTypeId = 1; // 500-740px arası her zaman tablet
        } else if (isTablet) {
            deviceTypeId = 2; // Diğer tabletler mobile gibi
        } else {
            deviceTypeId = 2; // Desktop
        }
        

        dispatch(
            actionGetStoryPages({ storyDetailId: storyDetailId, storyId: storyId, deviceTypeId: deviceTypeId }, (r) => {
                console.log('r', r.payload.data);
                if (r.type === 'SUCCESS') {
                    // Get Classic Objects
                    //setStoryPageAllData(r.payload.data);
                    setStoryPagesImageAllData(r.payload.data.content.find((item) => item.contentType === 'image')?.items);
                    setSounds(r.payload.data.content.find((item) => item.contentType === 'sound')?.items);
                    setAudioPlaying(true);
                    let pageImageData = r.payload.data.content.find((item) => item.contentType === 'image')?.items;
                    parseImage(pageImageData);
                }
            })
        );
    };

    const parseImage = (pageImageData) => {
        console.log('pageImageData', pageImageData);
        let allImages = pageImageData.sort(compareOrder);
        console.log('allImages', allImages);
        setStoryPageAllData(allImages);
        setTotalPageCount(allImages.length);
        setStoryPages(allImages)
        //setStoryPages(allImages.splice(0, 3))
        setOtherStoryPages(allImages.splice(4, allImages.length));
    }

    useEffect(() => {
        //TODO
        //getGroup(1);
    }, [storyPageAllData]);

    // Interactive Story
    const getGroup = (groupId) => {
        let startGroup = null;
        let startGroupItems = [];

        storyGroups.forEach((group) => {
            if (group.groupId === groupId) {
                startGroup = group;
            }
        });
        if (startGroup) {
            startGroupItems = [...startGroupItems, ...storyPages.filter((item) => item.storyGroupId === startGroup.groupId)];

            const filteredFork = storyPageAllData.forks.find((fork) => fork.id === startGroup.storyFileForkId);
            if (filteredFork) {
                startGroupItems.push(filteredFork);
            }

            // Check for End Of Story
            const checkFinishStory = startGroupItems.some((item) => item.endOfTheStory === true);
            if (checkFinishStory) {
                //  startGroupItems.push(FinishData); // Ensure you have defined FinishData somewhere
            }

            startGroupItems.sort((a, b) => a.queueNo - b.queueNo);

            // Assuming you have a Swiper ref to scroll to the top of the new group
            //swiper.slideTo(0);

            // Update the story pages with the items from the selected group
            setStoryPages(startGroupItems);
            // setStoryTransitionLoading(false);
        }
    };

    // Constructs the URL for story images and sounds
    const replaceObjectUrl = (url) => {
        return 'https://production.gokidly.com/education/api/v3/story/content/' + url;
    };

    // Renders a story page item as a background image
    const RenderItem = (item) => {
        const windowHeight = window.innerHeight;
        return (
            <div
                className={'storyItemImg'}
                style={{
                    backgroundImage: `url(${replaceObjectUrl(item.item.fileContent)})`,
            
                }}
            >
                {/*  //TODO {*/}
                {/*    item.item.firstChoiceGroupId && <div className={'forkGroup'}>*/}
                {/*        <div onClick={() => getGroup(2)} className={"forkItem"}></div>*/}
                {/*        <div onClick={() => getGroup(3)} className={"forkItem"}></div>*/}
                {/*    </div>*/}
                {/*}*/}
            </div>
        );
    };

    // Closes the modal, resets state, and stops audio
    const handleClose = () => {
        setActivePage(0);
        setStoryPages([]);
        setStoryPagesAllData([]);
        setStoryPagesImageAllData([]);
        setOtherStoryPages([]);
        audioRef.current.pause();
        handle.exit();
        dispatch(actionStoryReadingModalClose());
        setAudioPlaying(false);
    };

    const soundStateChange = () => {
        setSoundStatus(prevState => !prevState);
        audioRef.current.pause();
    }

    const onSlideChange = (e) => {
        setActivePage(e.activeIndex)
        console.log('e.activeIndex', e.activeIndex);
        console.log('storyPages.length', storyPages.length, totalPagesCount);
        if (e.activeIndex === 2 && storyPages.length < totalPagesCount) {
            let storyPagesTemp = [...storyPages, ...otherStoryPages];
            console.log('storyPagesTemp', storyPagesTemp);
            setStoryPages(storyPagesTemp)
        };
    }

    return (
        <>
            <Modal show={storyReadingModalOpen} onHide={handleClose} size={'xl'} fullscreen={true}>
                <Modal.Body className={'secondaryBg storyReadingModal'}>

                    <div className={'story-reading-wrap'} style={isMobile ? {
                        height: `${window.innerHeight}px`,
                        minHeight: `${window.innerHeight}px`,
                    } : {}}>
                        <Swiper
                            navigation={true}
                            modules={[Keyboard, Navigation]}
                            centeredSlides={false}
                            slidesPerView={isMobile || window.innerWidth <= 940 ? 1 : 2}
                            onSlideChange={(e) => onSlideChange(e)}
                        >

                            {storyPages.sort(compareOrder).map((item, index) => (
                                <SwiperSlide className={(index % 2 === 0 ? 'left-slide' : 'right-slide')} key={index}>
                                    <RenderItem item={item} />
                                </SwiperSlide>
                            ))}
                            <SwiperSlide key={32132}>
                                <div></div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <div className="controlButtons">
                        <div className={`control-buttons-content ${isControlsVisible ? 'visible' : ''}`}>
                            <a onClick={handleClose} className={'iconBtn exitBtn'}>
                                <div className={'icon icon-box-radius'}>
                                    <img src={exitIcon} alt='' />
                                </div>
                                <span>Çıkış</span>
                            </a>

                            <div onClick={soundStateChange} className={'iconBtn'}>
                                <div className={'icon icon-box-radius bg-blue'}>
                                    {soundStatus ? <i className={'fa fa-volume-off text-white fs-5'}></i> :
                                        <i className={'fa fa-volume-up text-white fs-5'}></i>}
                                </div>
                                <span>Ses</span>
                            </div>

                            <div className={'readingPageStatus'}>
                                <i className={'fa fa-book-open text-white'}></i>
                                <span>
                                    {activePage >= totalPagesCount ? activePage : activePage + 1} / {totalPagesCount}
                                </span>
                            </div>
                        </div>
                        <a className="controls-toggle-btn" onClick={() => setIsControlsVisible(!isControlsVisible)}>
                            <i className={`fa ${isControlsVisible ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </a>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer className={'secondaryBg non-border noBottomPadding'}>
                    <Button onClick={handleClose} className={'iconBtn iconBtn-alt'}>
                        <div className={'icon icon-box-radius'}>
                            <i className='fa-solid fa-times'></i>
                        </div>
                        <span>Kapat</span>
                    </Button>
                    <Button onClick={handle.enter} className={'iconBtn iconBtn-alt'}>
                        <div className={'icon bg-blue icon-box-radius'}>
                            <i className='fa fa-arrows-alt' aria-hidden='true'></i>
                        </div>
                        <span>Tam Ekran Yap</span>
                    </Button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
};

export { StoryReadingModal };
